import { SerializedData, Store } from "bernie-core";
import { RateCalendarStore } from "stores/rateCalendar/RateCalendarStore";
import { observable } from "mobx";
import { NewDatePickerContent } from "uitk-react-new-date-picker/dist/dependencies/new-date-picker-content-interface";
import { Logger, NOOP_LOGGER } from "bernie-logger";
import { RateCalendarFooterProps } from "components/flexComponents/WizardHotelPWA/components/RateCalendarFooter";
import { ExtendedContextStore, FlexContext } from "typings/flexFramework/FlexDefinitions";
import { Hotel } from "typings/microserviceModels/hotels-flex-module";

export class ClientRateCalendarStore extends Store implements RateCalendarStore {
  @observable
  public experimentBucket: number;

  @observable
  public isExperimentEnabled: boolean;

  @observable
  public datePickerContent: NewDatePickerContent;

  @observable
  public footerHtmlProps: RateCalendarFooterProps;

  @observable
  public footerText: string;

  constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  setup(flexContext: FlexContext, contextStore: ExtendedContextStore, hotels: Hotel[]): void {
    // does nothing
  }

  setFooterHtmlProps(): void {
    // does nothing
  }

  setFooterText(): void {
    // does nothing
  }
}
